import { useEffect, useState } from 'react';
import { TextureLoader, Texture } from 'three';

const useTexture = (url: string) => {
  const [data, setData] = useState<{
    texture: Texture;
    loaded: boolean;
  }>({
    texture: new Texture(),
    loaded: false,
  });

  useEffect(() => {
    let isMounted = true;

    const texture = new TextureLoader().load(
      url,
      () => {
        if (isMounted) {
          setData(data => ({
            ...data,
            loaded: true,
          }));
        }
      },
      undefined,
      e => {
        setData(data => ({
          ...data,
          loaded: true,
        }));
        console.log(`log: error: image load failed`, e);
      }
    );

    setData(data => ({
      ...data,
      texture,
      loaded: false,
    }));

    return () => {
      isMounted = false;
    };
  }, [url]);

  return data;
};

export default useTexture;
